"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var ReputationBar = function ReputationBar(_ref) {
  var reputationLevel = _ref.reputationLevel;
  return (0, _preact.h)("span", {
    className: "user-avatar--reputation-bar",
    style: {
      width: '100%'
    }
  }, (0, _preact.h)("span", {
    className: "reputation__level--".concat(reputationLevel)
  }));
};

var _default = ReputationBar;
exports.default = _default;